/*
 * @Author: xuesong
 * @Date: 2021-05-17 11:06:20
 * @LastEditTime: 2021-07-14 18:20:46
 * @LastEditors: enbo.zhou@dsicm.com
 * @Description: In User Settings Edit
 * @FilePath: /dsicm-admin-web/src/views/StandardDatabase/src/case-4/mixin.config.js
 */
export default {
    data() {
        return {
            homeColumnConfig: [
                {
                    label: '序号',
                    align: 'center',
                    fixed: 'left',
                    prop: 'id',
                    width: '50px',
                    render: (h, scope) => {
                        return <span slot="reference">{scope.$index * 1 + 1}</span>
                    },
                },
                {
                    label: '一级类目',
                    align: 'center',
                    prop: 'typeName1',
                    showOverflowTooltip: true
                },
                {
                    label: '一级类目代码',
                    align: 'center',
                    prop: 'typeCode1',
                    showOverflowTooltip: true
                },
        
                {
                    label: '二级类目代码',
                    align: 'center',
                    prop: 'typeCode2',
                },
                {
                    label: '二级类目名称',
                    align: 'center',
                    prop: "typeName2",
                    showOverflowTooltip: true
                },
                {
                    label: '三级类目代码',
                    align: 'center',
                    prop: 'typeCode3',
                    showOverflowTooltip: true
                },
                {
                    label: '三级类目名称',
                    align: 'center',
                    prop: 'typeName3',
                },
                {
                    label: '治疗项目名称',
                    align: 'center',
                    prop: 'name',
                },
                {
                    label: '治疗项目代码',
                    align: 'center',
                    prop: 'code',
                },
                {
                    label: '状态',
                    align: 'center',
                    render: (h, scope) => {
                        return <span slot="reference">{scope.row.enabled ? '已启用' :'已停用'}</span>
                    },
                },
                {
                    label: '操作',
                    align: 'center',
                    fixed: "right",
                    width: '150px',
                    render: (h, scope) => {
                        return h('div', [
                            h( 'el-button', {
                                props: { type: 'text', size: 'mini' },
                                on: {
                                click: () => {
                                    this.editHandel(scope.row)
                                },
                                },
                            }, '编辑' ),
                            h( 'el-button', {
                                props: { type: 'text', size: 'mini' },
                                //   attrs: {
                                //     disabled: scope.row.paymentState != 1 ? true : false,
                                //   },
                                on: {
                                    click: () => {
                                        this.blockUp(scope.row)
                                    },
                                },
                            }, scope.row.enabled ? '停用' :'启用'),
                            h( 'el-button',  {
                                props: { type: 'text', size: 'mini' },
                                on: {
                                click: () => {
                                    this.removeHandel(scope)
                                },
                                },
                            }, '删除'  ),
                        ])
                    },
                },
            ],
        }
    }
  }